import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: 'Поле обязательно для заполнения',
});

extend('email', {
    ...email,
    message: 'Введите корректный email',
});

extend('fio', {
    validate: (value) => (new RegExp(/([а-яА-ЯеЁ1-9]{2,})\s+([а-яА-ЯеЁ1-9]{2,})/)).test(value),
    message: 'Введите корректные ФИО',
});

extend('nameRu', {
    validate: (value) => /^[А-Яа-яёЁA-Za-z\s]+$/.test(value),
    message: 'Введите корректное имя',
});

extend('city', {
    validate: (value) => /^[А-Яа-яёЁ\-.,\s0-9]+$/.test(value),
    message: 'Введите корректный город',
});

extend('address', {
    validate: (value) => /^[A-Za-zА-Яа-яёЁ«»()/\-.,\s0-9]+$/.test(value),
    message: 'Введите корректный адрес',
});

extend('company', {
    validate: (value) => /^[А-Яа-яёЁA-Za-z«»()/\-."'\d\s]+$/.test(value),
    message: 'Введите корректное название компании',
});

extend('inn', {
    validate: (value) => /^[\d+]{10,12}$/.test(value),
    message: 'Введите корректный ИНН',
});

extend('bik', {
    validate: (value) => /^\d{9}$/.test(value),
    message: 'Введите корректный БИК банка',
});

extend('accountNumber', {
    validate: (value) => /^\d{20}$/.test(value),
    message: 'Введите корректный номер счета',
});

extend('bankName', {
    validate: (value) => /^[А-Яа-яёЁA-Za-z«»()\-."'\d\s]{4,}$/.test(value),
    message: 'Введите название банка',
});

extend('kpp', {
    validate: (value) => /^\d{9}$/.test(value),
    message: 'Введите корректный КПП',
});

extend('phone', {
    // eslint-disable-next-line
    validate: (value) => /^(\+7|7|8)?[\s\-]?\(?[1489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/.test(
        value,
    ),
    message: 'Введите корректный номер телефона',
});

const smsLong = 4;
const smsRegExp = new RegExp(`^[0-9]{${smsLong}}$`);

extend('smsCode', {
    validate: (value) => smsRegExp.test(value),
    // message: `Введите ${smsLong}-хзначный код из СМС`,
    message: 'Введите код из СМС',
});
